import React, { FunctionComponent } from 'react';

import FeatureFlags from '@Containers/Settings/AdminSettings/FeatureFlags';
import GlobalSettings from '@Containers/Settings/AdminSettings/GlobalSettings';

const GeneralSettingsLayout: FunctionComponent = (): JSX.Element => (
  <>
    <FeatureFlags />
    <GlobalSettings />
  </>
);

export default GeneralSettingsLayout;
